import { render, staticRenderFns } from "./FormReportes.vue?vue&type=template&id=1bb3c3b4"
import script from "./FormReportes.vue?vue&type=script&lang=js"
export * from "./FormReportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports